module.exports = [{"cmrId":"F02 988235","cmrCreationDate":"2018-11-07T05:00:00Z","pdfName":"F02 988235.pdf"},{"cmrId":"F02 988183","cmrCreationDate":"2018-11-07T05:00:00Z","pdfName":"F02 988183.pdf"},{"cmrId":"F02 988200","cmrCreationDate":"2018-11-07T05:00:00Z","pdfName":"F02 988200.pdf"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/mock-data/doc-list.json
// module id = F37t
// module chunks = 0